<app-view-select-filters *ngIf="nodeService.viewFilters" [block]="block" (onFiltered)="search($event)"></app-view-select-filters>
<ng-container *ngIf="results && results.length && !block.link_a_pagina_risultati">
    <ng-container *ngIf="block.bundle === 'blocco_corsi_di_laurea_tutti_'">
        <div class="container-title-corsi d-flex flex-column align-items-center justify-content-center">
            <h2 class="text-brand-10 ls-h2-section-title">{{"SEARCH_BAR.TTILE_PAGE" | translate}}</h2>
            <p class="text-neutral-40 ls-p">{{"SEARCH_BAR.SUBTITLE_PAGE" | translate}}</p>
        </div>
    </ng-container>
    <div class="container-view"
        [ngClass]="{'bg-neutral-95': block.bundle === 'blocco_tutti_gli_eventi' || block.bundle === 'blocco_tutte_le_news' || block.bundle === 'blocco_tutti_gli_avvisi'}">
        <div [ngSwitch]="block.oggetto_view" class="row container m-auto" [ngClass]="{
                'items-gap': block.oggetto_view === 'news',
                'general-gap': block.oggetto_view === 'corsi' || block.oggetto_view === 'docenti' || block.oggetto_view === 'bandi' || block.oggetto_view === 'faq-procedure',
                'convenzioniAndAlloggi': block.oggetto_view === 'convenzioni' || block.oggetto_view === 'alloggi'
            }">
            <div *ngFor="let resBlock of results" class="col-12" [ngClass]="{
                    'col-lg-6 p-3': block.oggetto_view === 'eventi',
                    'col-20': block.oggetto_view === 'docenti' || block.oggetto_view === 'persone',
                    'col-md-6 col-lg-3': block.oggetto_view === 'convenzioni' || block.oggetto_view === 'alloggi' || block.oggetto_view === 'pagine' || block.oggetto_view === 'faq-procedure',
                    'col-md-6 col-sm-6 col-xl-4': block.oggetto_view === 'corsi',
                    'col-md-6 col-lg-4': block.oggetto_view === 'avvisi' || block.oggetto_view === 'news' || block.oggetto_view === 'bandi',
                    'min-height': block.oggetto_view === 'corsi'
            }">
                <app-sample-card-corsi *ngSwitchCase="'corsi'" [dataCorsi]="resBlock"></app-sample-card-corsi>
                <app-sample-news-small *ngSwitchCase="'news'" [dataNews]="resBlock"></app-sample-news-small>
                <app-sample-card-avvisi *ngSwitchCase="'avvisi'" [block]="resBlock"></app-sample-card-avvisi>
                <app-sample-events-small *ngSwitchCase="'eventi'" [block]="resBlock"></app-sample-events-small>
                <app-sample-single-announcement *ngSwitchCase="'bandi'" [block]="resBlock"></app-sample-single-announcement>
                <app-sample-card-convention *ngSwitchCase="'convenzioni'" [block]="resBlock"></app-sample-card-convention>
                <app-sample-card-alloggi *ngSwitchCase="'alloggi'" [block]="resBlock"></app-sample-card-alloggi>
                <app-sample-card-faq *ngSwitchCase="'faq-procedure'" [block]="resBlock" [margin]="'m-1'"></app-sample-card-faq>
                <app-sample-card-pagine *ngSwitchCase="'pagine'" [block]="resBlock" [margin]="'mb-4'"></app-sample-card-pagine>
                <app-sample-card-docenti *ngSwitchCase="'docenti'" [block]="resBlock"></app-sample-card-docenti>
                <app-sample-card-persone *ngSwitchCase="'persone'" [block]="resBlock"></app-sample-card-persone>
            </div>
        </div>
        <div class="d-flex justify-content-center align-items-center p-5">
            <button class="btn-header-news ls-label-small-semibold text-uppercase" *ngIf="viewMore"
                (click)="addContentResult()">{{"SEARCH_BAR.SHOW_MORE" | translate}}</button>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="!results.length">
    <div class="mt-custom">
        <h2 class="text-center ls-h2-section-title text-brand-10">
            {{"SEARCH_BAR.NO_RESULTS" | translate}}
        </h2>
        <p class="text-center ls-p text-neutral-40">
            {{"SEARCH_BAR.MODIFY_SEARCH" | translate}}
        </p>
    </div>
</ng-container>